import { Component, Fragment } from "react"
import {
    DKLabel,
    DKInput,
    showToast,
    TOAST_TYPE,
    DKButton,
    showLoader,
    removeLoader,
    showAlert,
    DKIcon,
    DKIcons,
    DKLine,
    DKCheckMark
} from "deskera-ui-library";
import ic_arrow_back from "../../assets/icons/ic_arrow_back.svg";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { OvertimeService } from "./OvertimeService";
import Utility, { deepClone } from "../../utility/Utility";
import { DEFALUT_EFFECTIVE_DATE, ELIGIBILITY_SETTING_FORM, FIELD_TO_DISPLAY_IN_UNSELECTED_RULE, GENERAL_SETTING_FORM, OVERTIME_ACTIVATE_POPUP_FORM, OVERTIME_IMPORTANT_DETAILS, PAYOUT_SETTING_FORM, POLICY_STATUS } from "./OvertimeConstants";
import moment from "moment";
import DKInputDateTime from "../common/DKInputDateTime";
import { COMPANY_DATE_FORMATS, DATE_FORMAT, INPUT_TYPE } from "../../constants/Constant";
import PayrollService from "../../services/PayrollService";
import ComponentListService from "../../services/ComponentListService";
import OvertimeApiService from "../../services/OvertimeService";
import Popup from "../common/Popup";
import i18next from "i18next";
import { INPUT_VIEW_DIRECTION } from "../SequenceNumberFormat/Other";
import EmployeeListService from "../../services/EmployeeListService";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
import { isIndiaCompliance } from "../../managers/common/CommonUtil";
export default class OvertimeGeneralSetting extends Component {
    selectedRowData = OvertimeService.getOvertimeData();
    isSummary = false;
    defaultValues = {
        policyName:"",
        description:"",
        applicableToAll:'false',
        employees:[],

        breakHours:"00:00",
        all:"00:00",
        restDay:"00:00",
        offDay:"00:00",
        holiday:"00:00",
        regularDay:"00:00",
        halfDay:"00:00",

        maxOvertime:"",
        daily:"00:00",
        weekly:"00:00",
        monthly:"00:00",
        quarterly:"00:00",

        minHours:"00:00",
        blockTime:15,
        otToRoundOff:"ROUND_UP",
        hasExpiry:false,

        calculationType: "DAY_TYPE",
        calculationMethod:"FLAT",
        overtimePayrateCalculation:"",

        multiplierAll:"",
        multiplierRestDay:"",
        multiplierOffDay:"",
        multiplierHoliday: "",
        multiplierRegularDay: "",
        multiplierHalfDay: "",

        employeeCount:"",
        effectiveFrom :  DEFALUT_EFFECTIVE_DATE,
        updatedAt:"",
        updatedBy:"",
        createdAt:"",
        createdBy:"",
        remark: ""
    }
    employeeListForOption = [];
    OTOptions = []
    constructor(props) {
        super(props);
        this.state = {
            showActivatePop:false,
            isIncludeUnselectesRule:false,
            isLoadingPageData:false
        }
        RouteManager.setPresenter(this);
        this.modifyOTForm()
        this.selectedRowData = OvertimeService.getOvertimeData();
        if(this.selectedRowData) {
            this.selectedRowData = this.selectedRowData.rowData.data
            this.patchFormValues()
            
        } else if(!Utility.isEmpty(this.props.match.params.id)) {
            showLoader()
            OvertimeApiService.getOvertimePolicyById(this.props.match.params.id).then(res=>{
                if(res) {
                    this.selectedRowData = res;
                    this.patchFormValues()
                }
            },error=>{
                OvertimeService.setOvertimeData(null);
                RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_LIST);
            }).finally(()=>{
                removeLoader()
            });
        }
        this.defaultValues['employees'] = []
        this.getUsers();
        this.getComponent();
        this.getOTMultiplier();
        this.isSummary = this.props.isSummary
    }
    
    generalSettingForm = deepClone(GENERAL_SETTING_FORM);
    eligibilitySettingForm = deepClone(ELIGIBILITY_SETTING_FORM);
    payoutSettingForm = deepClone(PAYOUT_SETTING_FORM);
    overtimeImpDetailForm = deepClone(OVERTIME_IMPORTANT_DETAILS);
    overtimeImpDetailFormForPopup = deepClone(OVERTIME_IMPORTANT_DETAILS);
    otActivatePopup = deepClone(OVERTIME_ACTIVATE_POPUP_FORM);
    fieldToDisplayUnselectedRules = deepClone(FIELD_TO_DISPLAY_IN_UNSELECTED_RULE)
    componentDidMount() {
        RouteManager.setPresenter(this);
    }
    patchFormValues() {
        
        this.defaultValues = {
            ...this.defaultValues,
            ...this.selectedRowData,
            ...this.selectedRowData.breakHours,
            ...this.selectedRowData.maxOvertime,
            applicableToAll: this.selectedRowData.applicableToAll ? 'true' : 'false',
            multiplierAll: this.selectedRowData.multiplier?.all ? this.selectedRowData.multiplier.all : "",
            multiplierRestDay: this.selectedRowData.multiplier?.restDay ? this.selectedRowData.multiplier.restDay : "",
            multiplierOffDay: this.selectedRowData.multiplier?.offDay ? this.selectedRowData.multiplier.offDay : "",
            multiplierHoliday: this.selectedRowData.multiplier?.holiday ? this.selectedRowData.multiplier.holiday : "",
            multiplierRegularDay: this.selectedRowData.multiplier?.regularDay ? this.selectedRowData.multiplier.regularDay : "",
            multiplierHalfDay: this.selectedRowData.multiplier?.halfDay ? this.selectedRowData.multiplier.halfDay : "",
            
            // effectiveFrom: this.defaultValues.status =='ACTIVE' ? this.selectedRowData.effectiveFrom:null
        }
        if(this.selectedRowData.applicableToAll || this.employeeListForOption.length == 0) {
            this.defaultValues = {
                ...this.defaultValues,
                employees:[]
            }
        } else if(this.employeeListForOption.length != 0) {
            this.userListUpdate(this.employeeListForOption);
            this.updateState();
        }

        let actionDueIndex = this.eligibilitySettingForm.findIndex(field => field.columnCode == "actionDue");
        this.eligibilitySettingForm[actionDueIndex].uiVisible = this.defaultValues["hasExpiry"];
        
        const actionDueDateIndex = this.eligibilitySettingForm.findIndex(field => field.columnCode == "actionDueDate");
        this.eligibilitySettingForm[actionDueDateIndex].uiVisible = this.defaultValues["hasExpiry"]; 

        let flatIndex = this.payoutSettingForm.findIndex(field => field.columnCode == "flatAmount");
        let compIndex = this.payoutSettingForm.findIndex(field => field.columnCode == "component");
        if (this.defaultValues.calculationMethod === 'FLAT') {
            this.payoutSettingForm[flatIndex].uiVisible = true;
            this.payoutSettingForm[compIndex].uiVisible = false;
        } else if (this.defaultValues.calculationMethod === 'COMPONENT') {
            this.payoutSettingForm[flatIndex].uiVisible = false;
            this.payoutSettingForm[compIndex].uiVisible = true;
        } else {
            this.payoutSettingForm[flatIndex].uiVisible = false;
            this.payoutSettingForm[compIndex].uiVisible = false;
        }
    }
    getUsers() {
        showLoader()
        EmployeeListService.getEmployeesWithoutPage().then((res) => {
            if (res && res.users) {
                let empListInd = this.generalSettingForm.findIndex(field=>field.columnCode == 'employees');
                this.generalSettingForm[empListInd].options = res.users.filter(user=>{
                    user['id'] = user['userId'];
                    return !user.isTerminated;
                });
                this.employeeListForOption = this.generalSettingForm[empListInd].options ;
                this.userListUpdate(this.employeeListForOption);
                this.updateState();
            }
        }).finally(()=>{
            removeLoader()
        });
    }
    userListUpdate(list) {
        if(this.defaultValues.employeeDetails && !this.selectedRowData.applicableToAll ) {
            let empList  = [];
            this.defaultValues.employeeDetails.forEach((employee,empIndex)=>{
                if(employee.userId) {
                    let ind = list.findIndex(u=>employee.userId == u.userId);
                    if(ind != -1) {
                        empList.push(ind);
                    }
                }
            })
            this.defaultValues['employees'] = empList
        }
    }
    getComponent() {
        showLoader()
        ComponentListService.getAllComponent().then(res=>{
            if(res && res.components) {
                let ind = this.payoutSettingForm.findIndex(field=>field.columnCode == 'component');
                this.payoutSettingForm[ind].options = res.components;
                this.updateState()
            }
        }).finally(()=>{
            removeLoader();
        })
    }
    getOTMultiplier() {
        OvertimeApiService.getOvertimeMultiplier().then(res=>{
            if(res && res.overtimePayrollMultiplier && res.overtimePayrollMultiplier.overtimeMultiplierValues) {
                this.OTOptions = res.overtimePayrollMultiplier.overtimeMultiplierValues.map(ot=>ot.value);
                let ind = this.payoutSettingForm.findIndex(field=>field.columnCode == 'otMultiplier');
                if(ind != -1) {
                    this.payoutSettingForm[ind].subFields.forEach((field,index)=>{
                        field.options = this.OTOptions
                    })
                    this.updateState()
                }
            }
        })
    }
    modifyOTForm = () => {
        const calculationMethodIndex = this.payoutSettingForm.findIndex(field => field.columnCode == "calculationMethod");

        this.payoutSettingForm[calculationMethodIndex].options = isIndiaCompliance() ? [
            { id: "FLAT", name: "<b>Flat</b>" },
            { id: "COMPONENT", name: "Component" },
            { id: "CTC", name: "CTC" },
        ]:[
            { id: "FLAT", name: "<b>Flat</b>" },
            { id: "COMPONENT", name: "Component" }
        ];
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    getFieldValue(obj,viewOnly) {
        if (obj.options && obj.options.length != 0 && !obj.multiSelect) {
            if (obj.options[0].id) {
                const res = obj.options.find(o => o.id == (this.defaultValues[obj.key]?.id ? this.defaultValues[obj.key].id : this.defaultValues[obj.key]))
                if(viewOnly) {
                    return res.name
                }
                return  res;
            } else {
                return obj.options.find(o => o == this.defaultValues[obj.key])
            }
        } else if(viewOnly && obj.multiSelect) {
            const res = this?.defaultValues[obj?.key]?.map(i=>obj.options[i]?.name);
            return (res && res.join()) ? res.join() :"";
        }
        switch(obj.columnCode) {
            case "effectiveFrom":
                if(this.defaultValues.effectiveFrom == DEFALUT_EFFECTIVE_DATE) {
                    return null;
                }
                break;
            case "actionDueDate":
                if(this.defaultValues.hasExpiry && !Utility.isEmpty(this.defaultValues.actionDue) && !Utility.isEmpty(this.defaultValues['effectiveFrom']) && this.defaultValues.status ==POLICY_STATUS.ACTIVE) {
                    const actionDueDate = moment(this.defaultValues['effectiveFrom']).add(this.defaultValues.actionDue, 'days');
                    if(viewOnly) {
                        let dateFormat = COMPANY_DATE_FORMATS.filter(c => c.label == TenantService.get(TENANT.DATE_FORMAT))
                        dateFormat = dateFormat[0]?.label ? dateFormat[0].label : DATE_FORMAT.IND ;
                        return moment(actionDueDate).format(dateFormat);
                    } else {
                        return new Date(actionDueDate)
                    }
                    
                } else {
                    return null;
                }
        }
        
        return (obj.type == INPUT_TYPE.DATE) ? new Date(this.defaultValues[obj.key]):this.defaultValues[obj.key] ;
        
    }
    onChange(value, index, obj) {
        obj['canValidate'] = true
        if(obj.type == INPUT_TYPE.CHECKBOX) {
            this.defaultValues[obj.key] = !value
        } else if(!obj.multiSelect && !obj.hasMaxHours) {
            this.defaultValues[obj.key] =  value?.id ? value.id : value;
        } else if(obj.hasMaxHours) {
            if (!Utility.isEmpty(value)) {
                const hhMM = value.split(":");
                hhMM[1] = hhMM[1].length == 1 ? "0" + hhMM[1] : hhMM[1];
                hhMM[0] = hhMM[0].length == 1 ? "0" + hhMM[0] : hhMM[0];
                this.defaultValues[obj.key]= `${hhMM[0]}:${hhMM[1]}`
            }
            
        } else {
            this.defaultValues[obj.key] =  value;
        }

        switch(obj.key) {
            case "calculationMethod":
                let flatIndex = this.payoutSettingForm.findIndex(field=>field.columnCode == "flatAmount");
                let compIndex = this.payoutSettingForm.findIndex(field=>field.columnCode == "component");
                if(this.defaultValues[obj.key] === 'FLAT') {
                    this.payoutSettingForm[flatIndex].uiVisible = true;
                    this.payoutSettingForm[compIndex].uiVisible = false;
                } else if (this.defaultValues.calculationMethod === 'COMPONENT') {
                    this.payoutSettingForm[flatIndex].uiVisible = false;
                    this.payoutSettingForm[compIndex].uiVisible = true;
                } else {
                    this.payoutSettingForm[flatIndex].uiVisible = false;
                    this.payoutSettingForm[compIndex].uiVisible = false;
                }
                break;
            case "hasExpiry":
                let actionDueIndex = this.eligibilitySettingForm.findIndex(field=>field.columnCode == "actionDue");
                this.eligibilitySettingForm[actionDueIndex].uiVisible = this.defaultValues[obj.key];
                
                const actionDueDateIndex = this.eligibilitySettingForm.findIndex(field=>field.columnCode == "actionDueDate");
                this.eligibilitySettingForm[actionDueDateIndex].uiVisible = this.defaultValues[obj.key];
                break;
            case "applicableToAll":
                let employeeInd = this.generalSettingForm.findIndex(field=>field.columnCode == "employees");
                this.defaultValues['employees'] =[];
                this.generalSettingForm[employeeInd].readOnly = this.defaultValues[obj.key] == "true" ? true:false;
                break;
            case "all":
                this.defaultValues['restDay'] = this.defaultValues['all'];
                this.defaultValues['offDay'] = this.defaultValues['all'];
                this.defaultValues['holiday'] = this.defaultValues['all'];
                this.defaultValues['regularDay'] = this.defaultValues['all'];
                this.defaultValues['halfDay'] = this.defaultValues['all'];
                break;
            case 'restDay':
            case 'offDay':
            case 'holiday':
            case 'regularDay':
            case 'halfDay':
                this.defaultValues['all'] = "00:00";
                break;
            case "multiplierAll":
                this.defaultValues['multiplierRestDay'] = this.defaultValues['multiplierAll'];
                this.defaultValues['multiplierOffDay'] = this.defaultValues['multiplierAll'];
                this.defaultValues['multiplierHoliday'] = this.defaultValues['multiplierAll'];
                this.defaultValues['multiplierRegularDay'] = this.defaultValues['multiplierAll'];
                this.defaultValues['multiplierHalfDay'] = this.defaultValues['multiplierAll'];
                break;
            case "multiplierRestDay":
            case "multiplierOffDay":
            case "multiplierHoliday":
            case "multiplierRegularDay":
            case "multiplierHalfDay":
                this.defaultValues['multiplierAll'] = "";
                break;

            case "employees":
                let selectedEmployeeIds = value.map(v => obj.options[v]?.iamUserId);
                if (selectedEmployeeIds.length != 0) {
                    OvertimeApiService.getOvertimeByEmployee({ iamUserIds: selectedEmployeeIds }).then(res => {
                        if(res && res.status == 'FAILED') {
                            obj.isValid = true;
                        } else if(res && res.data) {
                            let list = res.data;
                            if(this.props?.match?.params?.id) {
                                list = list.filter(l=>l.id != this.props.match.params.id);
                            }
                            if(list.length != 0) {
                                obj.isValid = false;
                            } else if(list.length == 0) {
                                obj.isValid = true;
                            }
                            
                        } else {
                            obj.isValid = true;
                        }
                        this.updateState()
                    }, error => {
                        // obj.isValid = false;
                        this.updateState()

                    })
                } else {
                    obj.isValid = true;
                }
                break;
            case "policyName":
                if(Utility.isEmpty(value.trim())) {
                    obj.errorMessage = 'Please enter valid Policy name';
                } else {
                    obj.errorMessage = 'The policy name must not exceed 60 characters.';
                }
                break;
            case "flatAmount":
                if(!Utility.isEmpty(value.trim())) {
                    this.defaultValues[obj.columnCode] = Math.trunc(value);
                }
                break;
        }
        this.updateState()
    }
    validateForm(isFromActivePopup) {
        let isValid = true;
        this.canValidate = true;
        this.generalSettingForm.forEach(field => {
            if (field.uiVisible && field.required && field.type != INPUT_TYPE.NUMBER && field.type != "button" && !field.subFields && Utility.isEmpty(this.defaultValues[field.key])) {
                isValid = false;
            } else if (field.uiVisible && field.required && field.type == INPUT_TYPE.NUMBER && !field.subFields && field.type != "button" && Utility.isEmpty(this.defaultValues[field.key]?.toString())) {
                isValid = false;
            } else if(field.subFields && field.subFields.length != 0) {
                isValid = this.subFieldValidation(field.subFields,isValid)
            } else if (field.uiVisible && !field.isValid) {
                isValid = false;
            }
        })

        this.eligibilitySettingForm.forEach(field => {
            if (field.uiVisible && field.required && field.type != INPUT_TYPE.NUMBER && field.type != "checkbox" && !field.subFields  && Utility.isEmpty(this.defaultValues[field.key])) {
                isValid = false;
            } else if (field.uiVisible && field.required && field.type == INPUT_TYPE.NUMBER && !field.subFields && field.type != "checkbox" && Utility.isEmpty(this.defaultValues[field.key]?.toString())) {
                isValid = false;
            } else if(field.subFields && field.subFields.length != 0) {
                isValid = this.subFieldValidation(field.subFields,isValid)
            } else if (field.uiVisible && !field.isValid) {
                isValid = false;
            }
        })

        this.payoutSettingForm.forEach(field => {
            if (field.uiVisible && field.required && field.type != INPUT_TYPE.NUMBER && field.type != "button" && !field.subFields && Utility.isEmpty(this.defaultValues[field.key])) {
                isValid = false;
            } else if (field.uiVisible && field.required && field.type == INPUT_TYPE.NUMBER && !field.subFields && field.type != "button" && Utility.isEmpty(this.defaultValues[field.key]?.toString())) {
                isValid = false;
            } else if(field.subFields && field.subFields.length != 0) {
                isValid = this.subFieldValidation(field.subFields,isValid)
            } else if (field.uiVisible && !field.isValid) {
                isValid = false;
            }
        })
        if(!isValid && isFromActivePopup) {
            showToast('Please fill all required data before activate policy.',TOAST_TYPE.WARNING);
        } else if(isFromActivePopup) {
            this.otActivatePopup.forEach(field => {
                if (field.uiVisible && field.required && field.type != INPUT_TYPE.NUMBER && field.type != "button" && !field.subFields && Utility.isEmpty(this.defaultValues[field.key])) {
                    isValid = false;
                } else if (field.uiVisible && field.required && field.type == INPUT_TYPE.NUMBER && !field.subFields && field.type != "button" && Utility.isEmpty(this.defaultValues[field.key]?.toString())) {
                    isValid = false;
                } else if(field.subFields && field.subFields.length != 0) {
                    isValid = this.subFieldValidation(field.subFields,isValid)
                } else if (field.uiVisible && !field.isValid) {
                    isValid = false;
                }
            })
        }
        return isValid
    }
    subFieldValidation(subForm, isValid) {
        subForm.forEach(field => {
            if (field.uiVisible && field.required && field.type != INPUT_TYPE.NUMBER && field.type != "button" && Utility.isEmpty(this.defaultValues[field.key])) {
                isValid = false;
            } else if (field.uiVisible && field.required && field.type == INPUT_TYPE.NUMBER && field.type != "button" && Utility.isEmpty(this.defaultValues[field.key]?.toString())) {
                isValid = false;
            } else if (field.uiVisible && !field.isValid) {
                isValid = false;
            }
        })
        return isValid
    }
    onSave(status,isSave,isFromActicatePopup) {
        const isShift = TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED);
         if (!isShift) {
            showAlert("Please Enable Shift Management","You have enable Shift Management for use Overtime Policy.");
            return;
         }
        this.canValidate = true;
        this.updateState()
        setTimeout(()=>{
            if(!this.validateForm(isFromActicatePopup)) {
                this.updateState()
                return;
            }
            if(status == POLICY_STATUS.ACTIVE) {
                const selectedEmployeeIds = this.defaultValues.employees.map(v => this.employeeListForOption[v]?.iamUserId);
                this.checkIfSameUserAssignToPolicy(selectedEmployeeIds,status,isSave);
            } else {
                this.saveAPICall(status,isSave);
            }
            
        },100)
    }
    saveAPICall(status,isSave) {
        let param = this.prepaireJSONForSubmit(status);
            showLoader()
            OvertimeApiService.saveOvertimePolicy(param, this.selectedRowData?.id).then(res=>{
                if(isSave && PermissionUtils.hasAccess(MODULE.OVERTIME_POLICY, ACTION.EDIT)) {
                    OvertimeService.setOvertimeData(null);
                    setTimeout(()=>{
                        RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_SUMMARY+"/"+res.id);
                    },100)
                } else {
                    OvertimeService.setOvertimeData(null);
                    RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_LIST);
                }
                showToast(i18next.t("OT_UPDATE"),TOAST_TYPE.SUCCESS);
            },error=>{
                let errorMsg = "Internal Server Error";
                if(error?.code == 2 && !Utility.isEmpty(error?.message)) {
                    errorMsg = String(error.message).charAt(0).toUpperCase() + String(error.message).substring(1);
                }
                showToast(errorMsg,TOAST_TYPE.FAILURE)
            }).finally(()=>{
                removeLoader()
            })
    }
    checkIfSameUserAssignToPolicy = (selectedEmployeeIds,status,isSave) => {
        if (selectedEmployeeIds.length != 0) {
            OvertimeApiService.getOvertimeByEmployee({ iamUserIds: selectedEmployeeIds }).then(res => {
                if (res && res.status == 'FAILED') {
                    this.saveAPICall(status,isSave);
                } else if (res && res.data) {
                    let list = res.data;
                    if(this.props?.match?.params?.id) {
                        list = list.filter(l=>l.id != this.props.match.params.id);
                    }
                    if (list.length != 0) {
                       showToast(i18next.t('EMPLOYEE_EXIST'), TOAST_TYPE.FAILURE);
                        return;
                    } else if (list.length == 0) {
                        this.saveAPICall(status,isSave);
                    }
                } else {
                    this.saveAPICall(status,isSave);
                }
            }, error => {

            })
        } else {
            this.saveAPICall(status,isSave);
        }
    }
    prepaireJSONForSubmit(status) {
        
        let param = {
            policyName: this.defaultValues.policyName,
            description: this.defaultValues.description,
            remark: this.defaultValues.remark ? this.defaultValues.remark : "",
            breakHours: {
                all:this.defaultValues.all,
                restDay:this.defaultValues.restDay,
                offDay:this.defaultValues.offDay,
                holiday: this.defaultValues.holiday,
                regularDay: this.defaultValues.regularDay,
                halfDay: this.defaultValues.halfDay
            },
            maxOvertime: {
                daily:this.defaultValues.daily,
                weekly: this.defaultValues.weekly,
                monthly: this.defaultValues.monthly,
                quarterly: this.defaultValues.quarterly
            },
            multiplier: {
                all: this.defaultValues.multiplierAll,
                restDay: this.defaultValues.multiplierRestDay,
                offDay: this.defaultValues.multiplierOffDay,
                holiday: this.defaultValues.multiplierHoliday,
                regularDay: this.defaultValues.multiplierRegularDay,
                halfDay: this.defaultValues.multiplierHalfDay
            },
            minHours: this.defaultValues.minHours,
            otToRoundOff: this.defaultValues.otToRoundOff,
            blockTime: this.defaultValues.blockTime,
            hasExpiry: this.defaultValues.hasExpiry,
            actionDue: parseInt(this.defaultValues.actionDue),
            actionDueDate: !Utility.isEmpty(this.defaultValues.actionDueDate) ? moment(this.defaultValues.actionDueDate).toISOString():"",
            calculationType: this.defaultValues.calculationType,
            calculationMethod: this.defaultValues.calculationMethod,
            flatAmount: parseFloat(this.defaultValues.flatAmount),
            component: this.defaultValues.component?.id ? this.defaultValues.component.id:  (this.defaultValues.component?this.defaultValues.component:""),
            
            effectiveFrom: status != POLICY_STATUS.ACTIVE ?  DEFALUT_EFFECTIVE_DATE : (Utility.isEmpty(this.defaultValues.effectiveFrom)? moment().toISOString() : this.defaultValues.effectiveFrom),
            updatedAt: (Utility.isEmpty(this.defaultValues.updatedAt)? moment().toISOString() : this.defaultValues.updatedAt),
            status: status,
            activated: status == POLICY_STATUS.ACTIVE ? true:false,
            employees: this.defaultValues?.employees ? this.defaultValues.employees.map(e=>this.employeeListForOption[e].userId) : [],
            applicableToAll: (this.defaultValues.applicableToAll?.id ? this.defaultValues.applicableToAll.id : this.defaultValues.applicableToAll) == 'true' ? true:false
        }
        if(this.selectedRowData?.id) {
            param['id']=this.selectedRowData.id
        }
        return param;
        
    }
    renderHeader() {
        return (
            <>
                <div className="row cursor-hand mb-m" onClick={()=>{
                    OvertimeService.setOvertimeData(null);
                    RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_LIST);
                    }}>
                    <DKIcon className="ic-s  " src={ic_arrow_back} />
                    <DKLabel text="Back to list" />
                </div>
                <DKLabel className="fw-m fs-l" text="Policy Setting" />
            </>
        )
    }
    isRequired = (validation) => {
        return validation ? validation.findIndex((v) => v[0] === "required") !== -1 : false;
    }
    renderFormField = (obj, index) => {
        return (
            <div id={obj.columnCode}>
                {(obj.type != "date-time-input" && obj.type != INPUT_TYPE.CHECKBOX) && <DKInput
                    className={` ${obj.direction == INPUT_VIEW_DIRECTION.HORIZONTAL ? "mb-l ":"p-v-s p-h-l mb-l"}`}
                    icon={obj.icon}
                    title={obj.name}
                    placeholder={obj.name}
                    value={this.getFieldValue(obj)}
                    options={obj.options}
                    type={obj.type}
                    errorMessage={obj.errorMessage}
                    labelClassName=" text-align-left "
                    canValidate={obj['canValidate'] || this.canValidate}
                    onChange={(value) => {
                        this.onChange(value, index, obj);
                    }}
                    validator={(value) => {
                        
                        if(obj.columnCode == "employees") {
                            return obj.isValid;
                        } else if (obj.validation && obj.validation.regExp) {
                            const regex = new RegExp(obj.validation.regExp);
                            obj.isValid = regex.test(value.trim());
                            return regex.test(value.trim());
                        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
                            obj.isValid = false
                            return false;
                        } else if (obj.required && Utility.isEmpty(value)) {
                            obj.isValid = false
                            return false;
                        } else {
                            obj.isValid = true;
                            return true;
                        }
                    }}
                    formatter={(obj) => {
                        /** How to render a selected option in case of object **/
                        return (obj && obj.name) ? obj.name : obj;
                    }}
                    displayKey="name"
                    dropdownConfig={{
                        checkMarkColor: "bg-app",
                        className: "",
                        style: {},
                        multiSelect: obj.multiSelect,
                        data: obj.options,
                        allowSearch:
                        obj.options && obj.options.length > 6 ? true : false,
                        searchableKey: "name",
                        button: (!Utility.isEmpty(obj.buttonConfig) && obj.options.length == 0 && false)
                            ? {
                                title: obj.buttonConfig.title,
                                onClick: (e) => {
                                  RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_RATE_CONFIG)
                                },
                                className: obj.buttonConfig.className,
                              }
                            : false,
                        renderer: (index, obj) => {
                            /** How to render value in Dropdown in case of object **/
                            return <DKLabel text={`${obj?.name ? obj.name: obj}`} />;
                        },
                        onSelect: (index, obj) => {

                        },
                    }}
                    direction={obj.direction}
                    required={obj.required}
                    readOnly={obj.readOnly || (this.isSummary && obj.direction != INPUT_VIEW_DIRECTION.HORIZONTAL)}
                    tooltip={{
                        content: obj.tooltipText,
                        className: "warning-tooltip-prop",
                      }}
                />}
                {
                    obj.type == "date-time-input" && <DKInputDateTime
                    is12Hour={false}
                    className="p-v-s p-h-l mb-m"
                    labelClass={"mt-xs"}
                    direction={obj.direction}
                    readOnly={this.isSummary}
                    title={obj.required ? `${obj.name} *` : obj.name}
                    hideCalendar={true}
                    hideFooterDateTime={true}
                    selectedDate={
                        (obj.hasMaxHours) ? this.getFieldValue(obj):moment(this.getFieldValue(obj), "HH:mm").format()
                    }
                    errorMessage={obj.errorMessage}
                    invalid={obj.invalid}
                    hasMaxHours={obj.hasMaxHours}
                    onSave={(date) => {
                        if(obj.hasMaxHours) {
                            this.onChange(date, index, obj);
                        } else {
                            this.onChange(moment(date).format("HH:mm"), index, obj);
                        }
                        
                    }}
                />
                }
                {
                    obj.type == INPUT_TYPE.CHECKBOX &&
                    <div className="row  p-h-l " key={obj.columnCode}>
                        <div onClick={() => {
                            if(!this.isSummary) {
                                this.onChange(this.defaultValues[obj.columnCode], index, obj)
                            }
                        }}>
                            <DKCheckMark
                                isSelected={this.defaultValues[obj.columnCode]}
                                color="bg-app"
                            />
                        </div>
                        <DKLabel className="ml-s" text={obj.name} />
                    </div>
                }
            </div>
        )
    }
    generalSetting() {
        return (
            <div className="row row-responsive flex-wrap bg-white border-m border-radius-s pb-s mt-m">
                <DKLabel text="General Settings" className="fw-m fs-m p-m" />
                <DKLine className="bg-line-2 mb-s" />
                {this.generalSettingForm.map((field, index) => {
                    return <div className="web-width-50">{this.renderFormField(field, index)}</div>
                })}
            </div>
        )
    }
    eligibilitySetting() {
        return (
            <div className="parent-width bg-white border-m border-radius-s pb-s mt-xl">
                <DKLabel text="Eligibility Settings" className="fw-m fs-m p-m" />
                <DKLine className="bg-line-2 " />

                
                {this.eligibilitySettingForm.map((field, index) => {
                    if(field.subFields) {
                        return (
                            <div className="p-l">
                                <DKLabel text={field.name} className="fw-m" />
                                <div className="row row-responsive flex-wrap border-m border-radius-s"> {
                                    field.subFields.map((subField, subIndex) => {
                                        return <div className="web-width-50">{this.renderFormField(subField, subIndex)}</div>
                                    })
                                }
                                </div>
                            </div>
                            
                        )
                    }
                    
                })}
                <div className="row row-responsive flex-wrap">
                {this.eligibilitySettingForm.map((field, index) => {
                    if(!field.subFields && field.uiVisible) {
                        return  <div className="web-width-50">{this.renderFormField(field, index)}</div>
                        
                    }
                })}

                             
                </div>
            </div>
            
        )
    }
    payoutSetting() {
        return (
            <div className="parent-width bg-white border-m border-radius-s pb-s mt-xl">
                <DKLabel text="Payout Settings" className="fw-m fs-m p-m" />
                <DKLine className="bg-line-2 " />
                {this.payoutSettingForm.map((field, index) => {
                    if (field.subFields) {
                        return (
                            <div className="p-l">
                                <DKLabel text={field.name} className="fw-m" />
                                <div className="row row-responsive flex-wrap border-m border-radius-s pt-m"> {
                                    field.subFields.map((subField, subIndex) => {
                                        return <div className="web-width-50">{this.renderFormField(subField, subIndex)}</div>
                                    })
                                }
                                </div>
                            </div>
                        )
                    }

                })}
                <div className="row row-responsive flex-wrap">
                    {this.payoutSettingForm.map((field, index) => {
                        if (!field.subFields) {
                            return field.uiVisible && <div className="web-width-50">{this.renderFormField(field, index)}</div>

                        }
                    })}


                </div>
            </div>
        )
    }
    getActivateSection() {
        return(
            <div className='row  p-h-l mb-m'>
                {(this.defaultValues.status !=POLICY_STATUS.ACTIVE && PermissionUtils.hasAccess(MODULE.OVERTIME_POLICY, [ACTION.EDIT])) && <>
                <DKButton title="Activate" className="border-m bg-app text-white" onClick={()=>{this.setState({showActivatePop:true})}}/>
                <DKLabel className="pl-l" text="You can click on Active button to Activate Policy."/>
                </>}
                {this.defaultValues.status ==POLICY_STATUS.ACTIVE&&<div className="row" onClick={()=>{this.onSave(POLICY_STATUS.DRAFT,false,true)}}>
                <DKCheckMark
                                isSelected={true}
                                color="bg-app cursor-hand"
                            />
                <DKLabel className="pl-l" text="Overtime Policy is Activated."/>
                </div>}
            </div>
        )
    }
    getMoreInfo() {
        return(
            <div className=' p-h-l mb-m'>
                <DKButton title="Info" className="border-m bg-gray1 w-fit-content" onClick={()=>{this.setState({showInfoPop:true})}}/>
                
               
            </div>
        )
    }
    getImportantDetail() {
        return (
            <div className="parent-width bg-white border-m border-radius-s pb-s mt-xl">
                <DKLabel text="Important Details" className="fw-m fs-m p-m" />
                <DKLine className="bg-line-2 " />
                {this.overtimeImpDetailForm.map((field, index) => {
                    if (field.subFields) {
                        return (
                            <div className="p-l">
                                <DKLabel text={field.name} className="fw-m" />
                                <div className="row row-responsive flex-wrap border-m border-radius-s pt-m"> {
                                    field.subFields.map((subField, subIndex) => {
                                        return <div className="web-width-50">{this.renderFormField(subField, subIndex)}</div>
                                    })
                                }
                                </div>
                            </div>
                        )
                    }

                })}
                <div className="row row-responsive flex-wrap pt-m">
                    {this.overtimeImpDetailForm.map((field, index) => {
                        if (!field.subFields) {
                            return field.uiVisible && <div className="web-width-50">{this.renderFormField(field, index)}</div>

                        }
                    })}
                </div>
                {this.isSummary && this.getMoreInfo()}
                {this.isSummary && this.getActivateSection()}
            </div>
        )
    }
    getActionButton() {
        return(
            <div className="row mt-l">
                <DKButton className="bg-app text-white" title="Save and review" onClick={()=>{
                    const status = this.defaultValues.status == POLICY_STATUS.ACTIVE ?this.defaultValues.status:POLICY_STATUS.DRAFT;
                    this.onSave(status,true);
                }}/>
                <DKButton className="bg-app text-white ml-m" title="Save as Draft" onClick={()=>{
                    this.onSave(POLICY_STATUS.DRAFT)
                }}/>
                <DKButton className="bg-gray1 border-m ml-m" title="Cancel" onClick={()=>{OvertimeService.setOvertimeData(null);RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_LIST);}}/>
            </div>
        )
    }
    getActivatePopup() {
        return(
            <>
            {this.state.showActivatePop && <Popup popupClass={"popup-overflow"} onClose={() => this.setState({showActivatePop:false})}>
                    <div className="parent-width">
                        <div className="d-flex">
                            <DKLabel text={"Activating the Policy"} className="fs-l fw-b" />
                            <div className="ml-auto d-flex">
                                <DKButton
                                    title={i18next.t("CANCEL")}
                                    className="border-radius-m bg-gray1 border-m"
                                    onClick={() => {
                                        this.setState({ showActivatePop: false })
                                    }}
                                />
                                <DKButton
                                    title={i18next.t("Activate")}
                                    className="bg-app text-white ml-m"
                                    onClick={() => {
                                        this.onSave(POLICY_STATUS.ACTIVE,false,true)
                                    }}
                                />

                            </div>
                        </div>
                        <div className="row row-responsive flex-wrap pt-m">
                            {this.otActivatePopup.map((subField, subIndex) => {
                                return <div className="parent-width">{this.renderFormField(subField, subIndex)}</div>
                            })}
                        </div>

                    </div>
                </Popup>}
            </>
        )
    }
    getInfoPopup() {
        return (
            <>
                {this.state.showInfoPop && <Popup popupClass={"popup-overflow"} onClose={() => this.setState({ showInfoPop: false })}>
                    <div className="parent-width">
                        <div className="row">
                            <DKLabel text={"Important Details"} className="fs-l fw-b" />
                            <div className="ml-auto d-flex">
                                <DKButton
                                    title={i18next.t("CANCEL")}
                                    className="border-radius-m bg-gray1 border-m"
                                    onClick={() => {
                                        this.setState({ showInfoPop: false })
                                    }}
                                />
                            </div>
                        </div>

                        <div className="parent-width ">
                            {this.overtimeImpDetailFormForPopup.map((field, index) => {
                                if (field.subFields) {
                                    return (
                                        <div className="p-l">
                                            <DKLabel text={field.name} className="fw-m" />
                                            <div className="row row-responsive flex-wrap border-m border-radius-s pt-m"> {
                                                field.subFields.map((subField, subIndex) => {
                                                    subField['readOnly'] = true;
                                                    subField['direction'] = INPUT_VIEW_DIRECTION.HORIZONTAL;
                                                    return <div className="parent-width">{this.renderFormField(subField, subIndex)}</div>
                                                })
                                            }
                                            </div>
                                        </div>
                                    )
                                }

                            })}
                            <div className="row row-responsive flex-wrap pt-m">
                                {this.overtimeImpDetailFormForPopup.map((field, index) => {
                                    field['direction'] = INPUT_VIEW_DIRECTION.HORIZONTAL;
                                    field['readOnly'] = true;
                                    return <div className="parent-width">{this.renderFormField(field, index)}</div>
                                })}
                            </div>
                        </div>

                    </div>
                </Popup>}
            </>
        )
    }
    getUnselectedRule() {
        return (
            <div className="parent-width bg-white border-m border-radius-s pb-s mt-xl">
                <DKLabel text="Include Unselected Rules" className="fw-m fs-m p-m" />
                <DKLine className="bg-line-2 " />
                <div className="row  p-h-l mt-r" key={'isIncludeUnselectesRule'}>
                    <div onClick={() => {
                        this.setState({
                            isIncludeUnselectesRule: !this.state.isIncludeUnselectesRule
                        })
                    }}>
                        <DKCheckMark
                            isSelected={this.state.isIncludeUnselectesRule}
                            color="bg-app"
                        />
                    </div>
                    <DKLabel className="ml-s" text={'Include Unselected Rules'} />

                </div>
                {/* /////////////////General Settings///////////////////// */}
                <div className="row row-responsive flex-wrap bg-white  pb-s mt-m">
                    <DKLabel text="General Settings" className="fw-m fs-m p-m" />
                    <DKLabel className="row" text=" " />
                    {this.generalSettingForm.map((field, index) => {
                        let value = this.getFieldValue(field, true)?.id ? this.getFieldValue(field, true).id : this.getFieldValue(field, true);
                        if (!Utility.isEmpty(value)) {
                            return <div className="web-width-50">{this.renderViewOnlyFields(field, index, value)}</div>
                        }
                    })}

                </div>

                {/* /////////////Eligibility Settings//////////// */}

                <div className="parent-width bg-white  pb-s mt-xl">
                    <DKLabel text="Eligibility Settings" className="fw-m fs-m p-m" />
                    <DKLabel className="row" text=" " />


                    {this.eligibilitySettingForm.map((field, index) => {
                        if (field.subFields) {
                            return (
                                <div className="p-l">
                                    <DKLabel text={field.name} className="fw-m" />
                                    <div className="row row-responsive flex-wrap border-m border-radius-s"> {
                                        field.subFields.map((subField, subIndex) => {
                                            let value = this.getFieldValue(subField, true)?.id ? this.getFieldValue(subField, true).id : this.getFieldValue(subField, true);
                                            const isVisible = value != "00:00" ? (value) : (((value == "00:00" || Utility.isEmpty(value)) && this.state.isIncludeUnselectesRule) ? value:false )
                                            if (!Utility.isEmpty(value)&& isVisible ) {
                                                return <div className="web-width-50">{this.renderViewOnlyFields(subField, subIndex, value)}</div>
                                            }
                                        })
                                    }
                                    </div>
                                </div>

                            )
                        }

                    })}
                    <div className="row row-responsive flex-wrap">
                        {this.eligibilitySettingForm.map((field, index) => {
                            if (!field.subFields && field.uiVisible) {
                                let value = this.getFieldValue(field, true)?.id ? this.getFieldValue(field, true).id : this.getFieldValue(field, true);
                                const isVisible = value != "00:00" ? (value) : (((value == "00:00" || Utility.isEmpty(value)) && this.state.isIncludeUnselectesRule) ? value:false )
                                if (!Utility.isEmpty(value) && isVisible ) {
                                    return <div className="web-width-50">{this.renderViewOnlyFields(field, index, value)}</div>
                                }

                            }
                        })}


                    </div>
                </div>

                {/* \\\\\\Payout Settings\\\\ */}
                <div className="parent-width bg-white  pb-s mt-xl">
                    <DKLabel text="Payout Settings" className="fw-m fs-m p-m" />
                    <DKLabel className="row" text=" " />


                    {this.payoutSettingForm.map((field, index) => {
                        if (field.subFields) {
                            return (
                                <div className="p-l">
                                    <DKLabel text={field.name} className="fw-m" />
                                    <div className="row row-responsive flex-wrap border-m border-radius-s"> {
                                        field.subFields.map((subField, subIndex) => {
                                            let value = this.getFieldValue(subField, true)?.id ? this.getFieldValue(subField, true).id : this.getFieldValue(subField, true);
                                            const isVisible = value != "00:00" ? (value) : (((value == "00:00" || Utility.isEmpty(value)) && this.state.isIncludeUnselectesRule) ? value:false )
                                            if (!Utility.isEmpty(value)&& isVisible ) {
                                                return <div className="web-width-50">{this.renderViewOnlyFields(subField, subIndex, value)}</div>
                                            }
                                        })
                                    }
                                    </div>
                                </div>

                            )
                        }

                    })}
                    <div className="row row-responsive flex-wrap">
                        {this.payoutSettingForm.map((field, index) => {
                            if (!field.subFields && field.uiVisible) {
                                let value = this.getFieldValue(field, true)?.id ? this.getFieldValue(field, true).id : this.getFieldValue(field, true);
                                const isVisible = value != "00:00" ? (value) : (((value == "00:00" || Utility.isEmpty(value)) && this.state.isIncludeUnselectesRule) ? value:false )
                                if (!Utility.isEmpty(value)&& isVisible ) {
                                    return <div className="web-width-50">{this.renderViewOnlyFields(field, index, value)}</div>
                                }

                            }
                        })}


                    </div>
                </div>

            </div>
        )
    }
    renderViewOnlyFields(field,index,value) {
        
        return (
            <div className="p-m p-h-l">
                <DKLabel className="fw-m" text={field.name}/>
                <DKLabel text={value}/>
            </div>
        )
    }
    render() {
        return (
            <Fragment>
                {!this.isSummary && this.renderHeader()}
                {this.isSummary && this.getUnselectedRule()}
                {this.isSummary && this.getImportantDetail()}
                {this.isSummary && <DKLabel className="fw-m fs-l mt-l" text="Overview of Setting"/>}
                {this.generalSetting()}
                {this.eligibilitySetting()}
                {this.payoutSetting()}
                {!this.isSummary && this.getActionButton()}
                {this.getActivatePopup()}
                {this.getInfoPopup()}
            </Fragment>
        )
    }
}